import { render } from "./SignerDetails.vue?vue&type=template&id=145f100c&scoped=true"
import script from "./SignerDetails.vue?vue&type=script&lang=js"
export * from "./SignerDetails.vue?vue&type=script&lang=js"

import "./SignerDetails.vue?vue&type=style&index=0&id=145f100c&scoped=true&lang=css"

import exportComponent from "D:\\a\\1\\s\\eNotary.SPA\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-145f100c"]])

export default __exports__